const triggerDisabled = "data-trigger-disabled";
export {
  triggerDisabled
};
//# sourceMappingURL=TooltipTriggerDataAttributes.js.map
